import { Fragment, type ReactNode } from "react"

type Translate = (key: string, values?: Record<string, string | number>) => string

/** An invisible separator: never typed in a message, so it can mark where an emphasised value goes. */
const MARK = "⁣"

/**
 * A translated sentence with some values emphasised. The message stays whole in the catalog (word order is the
 * locale's), and each `{name}` listed in `strong` is rendered bold with its own class.
 */
export function richSentence(
  t: Translate,
  key: string,
  values: Record<string, string | number>,
  strong: Record<string, { text: string; className?: string }>,
): ReactNode {
  const marked = Object.fromEntries(Object.keys(strong).map((name) => [name, `${MARK}${name}${MARK}`]))
  const parts = t(key, { ...values, ...marked }).split(MARK)
  return parts.map((part, index) => {
    const value = index % 2 === 1 ? strong[part] : undefined
    return value ? (
      <b key={index} className={value.className ?? "text-foreground"}>
        {value.text}
      </b>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    )
  })
}
